import { getAttribution } from "@/app/libs/attribution";

/**
 * Fire-and-forget analytics beacon from client components (checkout funnel).
 * Mirrors the pattern in AnalyticsTracker / SearchClient: never throws,
 * keepalive so the event survives an immediate navigation.
 */
export default function trackClientEvent(
  type:
    | "booking_start"
    | "checkout_view"
    | "pay_click"
    | "checkout_validation_failed"
    | "account_create_failed"
    | "payment_started"
    | "payment_failed"
    | "pending_created"
    | "pending_resumed"
    | "abandon_reason",
  payload: { listingId?: string; metadata?: Record<string, unknown> } = {},
): void {
  try {
    fetch("/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, ...payload, attribution: getAttribution() }),
      keepalive: true,
    }).catch(() => {
      // Silent fail to avoid affecting UX
    });
  } catch {
    // Silent fail to avoid affecting UX
  }
}
